export default "__VITE_ASSET__DTqFY9nD__"